import { combineReducers } from "@reduxjs/toolkit";

import auth from './auth/reducer';

export default combineReducers({
  auth
});
